import axios from "./axios";;

let IdentificationCheckLookup = function(config) {
  config.timeout = 30000;
  this.axios = axios(config);
  this.type = "identification_check_lookup";
};

IdentificationCheckLookup.prototype.getIdentificationCheckLookup = function(
  success,
  error,
  options = {},
) {
  return this.axios
    .get(`/${this.type}`, options)
    .then(success)
    .catch(error);
};

export default IdentificationCheckLookup;
